import { TableRow, TableCell } from "@/components/ui/table";
import { flexRender, Row } from "@tanstack/react-table";
import React from "react";

export const CellHoverClassName = "group-hover:bg-blue-100 transition-colors duration-150 ";

export const TableDataRow = <TData,>({
	row,
	renderRowClassName,
	renderCell,
	rowClassName = "",
}: {
	row: Row<TData>;
	renderRowClassName?: (row: Row<TData>) => string;
	renderCell?: (cell: any) => React.ReactNode;
	rowClassName?: string;
}) => {
	return (
		<TableRow
			key={row.id}
			data-state={row.getIsSelected() && "selected"}
			className={`group cursor-pointer ${renderRowClassName?.(row) ?? ""} ${rowClassName}`}
			onClick={event => {
				const target = event.target as HTMLElement;
				if (target.closest('a, button, input, select, textarea, label, [role="button"], [role="menuitem"]')) {
					return;
				}
				row.toggleExpanded();
			}}
		>
			{row.getVisibleCells().map(cell => {
				const columnDef = cell.column.columnDef;
				const shouldWrap = columnDef.meta?.wrapWithTableCell !== false;
				const content = renderCell ? renderCell(cell) : flexRender(columnDef.cell, cell.getContext());

				return shouldWrap ? (
					<TableCell key={cell.id} className={CellHoverClassName + (columnDef.meta?.cellClassName || "")}>
						{content}
					</TableCell>
				) : (
					<React.Fragment key={cell.id}>{content}</React.Fragment>
				);
			})}
		</TableRow>
	);
};
